<template>
  <article>
    <div class="mb-3 col-12 col-md-9">
      <label for="password" class="form-label">Jetziges Passwort</label>
      <div class="input-group mb-3">
        <input type="password" class="form-control" aria-describedby="basic-addon1" id="currentPassword" v-model="currentPassword" />
        <span class="btn btn-outline-primary input-group-text" id="basic-addon1" @click="$store.state.utils.switTypeInput">
          <i class="fa-solid fa-eye"></i>
        </span>
      </div>
    </div>
    <div class="mb-3 col-12 col-md-9">
      <label for="password" class="form-label">Neues Passwort</label>
      <input type="password" class="form-control" id="password" v-model="newPassword" />
      <div class="form-text font-size-12 mx-1 row">
        <div
          :class="
            has_lowercsae
              ? 'has_required text-white p-1 bg-primary col'
              : 'p-1 col bg-white'
          "
          title="At least one lowercase letter"
        ></div>
        <div
          :class="
            has_uppercase
              ? 'has_required text-white p-1 bg-primary col'
              : 'p-1 col bg-white'
          "
          title="At least one uppercase letter"
        ></div>
        <div
          :class="
            has_number
              ? 'has_required text-white p-1 bg-primary col'
              : 'p-1 col bg-white'
          "
          title="At least one Number"
        ></div>
        <div
          :class="
            has_minimum_lenth
              ? 'has_required text-white p-1 bg-primary col'
              : 'p-1 col bg-white'
          "
          title="At least 8 chacters"
        ></div>
        <div
          :class="
            has_special
              ? 'has_required text-white p-1 bg-primary col'
              : 'p-1 col bg-white'
          "
          title="At least one special character"
        ></div>
      </div>
    </div>
    <div class="mb-3 col-12 col-md-9">
      <label for="repeatPassword" class="form-label">Passwort wiederholen</label>
      <input type="password" class="form-control" id="repeatPassword" v-model="repeatPassword" aria-describedby="repeatPass" />
      <div id="repeatPass" class="form-text" :class="newPassword === repeatPassword && newPassword.length > 7 ? ' text-success': 'd-none'">
        Passwort stimmt überein
      </div>
    </div>
    <div>
      <button
        v-if="
          this.currentPassword.length > 7 &&
          this.newPassword.length > 7 &&
          this.newPassword != this.currentPassword
        "
        @click="updatePass"
        class="btn btn-outline-primary"
      >
        <span>Speichern</span>
      </button>
      <button v-else class="btn btn-outline-primary disabled" disabled>
        <span>Speichern</span>
      </button>
    </div>
  </article>
</template>

<script>
export default {
  name: "Setting",

  data() {
    return {
      currentPassword: "",
      newPassword: "",
      repeatPassword: "",

      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.utils.loaded = true;
    });
  },

  watch: {
    newPassword() {
      const val = this.$store.state.utils.filters.password(this.newPassword);

      this.has_minimum_lenth = val.has_minimum_lenth;
      this.has_number = val.has_number;
      this.has_lowercsae = val.has_lowercsae;
      this.has_uppercase = val.has_uppercase;
      this.has_special = val.has_special;

      this.passwordIsCorrect =
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth;
    },
  },

  methods: {
    updatePass() {
      event.preventDefault();

      if (
        this.newPassword.length < 7 &&
        this.newPassword !== this.repeatPassword
      )
        return;

      this.$store.state.utils.processing = true;

      this.$store.state.modules.api
        .updatePassword(
          {
            newPassword: this.newPassword,
            currentPassword: this.currentPassword,
          },
          JSON.parse(localStorage.account).token
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Passwort aktualisieren",
                message: "Dein Passwort wurde aktualisiert",
              },
              2500
            );
            this.$router.push({ name: "CPanel" });
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
          }
          this.$store.state.utils.processing = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
